import { createFileRoute } from "@tanstack/react-router";
import { ModuleDashboard } from "@/features/dashboards/ModuleDashboard";

// Sales dashboard (PX-SAL-010): features/dashboards.
export const Route = createFileRoute("/_app/sales/dashboard")({
  component: () => <ModuleDashboard module="sales" />,
});
